import { createSelector } from '@reduxjs/toolkit';
import { IStoreState } from 'redux/types';
import { IModerationState } from './types';

// Base
const getModerationState = (state: IStoreState): IModerationState => state.moderation;

// loader
export const getModerationLoaderSelector = createSelector(
  [getModerationState],
  (moderation: IModerationState): boolean => moderation.moderationLoader,
);

// counters
export const getModerationCountersSelector = createSelector(
  [getModerationState],
  (moderation: IModerationState) => moderation.counters,
);

// List reports
export const getModerationReportsSelector = createSelector(
  [getModerationState],
  (moderation: IModerationState) => moderation.reportsResponse,
);

// flags
export const getModerationFlagsSelector = createSelector(
  [getModerationState],
  (moderation: IModerationState) => moderation.flagsResponse,
);

// approve
export const getModerationApproveSelector = createSelector(
  [getModerationState],
  (moderation: IModerationState) => moderation.approveResponse,
);

// reject
export const getModerationRejectSelector = createSelector(
  [getModerationState],
  (moderation: IModerationState) => moderation.rejectResponse,
);

// users
export const getModerationUsersSelector = createSelector(
  [getModerationState],
  (moderation: IModerationState) => moderation.usersResponse,
);

// channels
export const getModerationChannelsSelector = createSelector(
  [getModerationState],
  (moderation: IModerationState) => moderation.channelsResponse,
);

// top users
export const getTopUsersSelector = createSelector(
  [getModerationState],
  (moderation: IModerationState) => moderation.topUsers,
);

// top channels
export const getTopChannelsSelector = createSelector(
  [getModerationState],
  (moderation: IModerationState) => moderation.topChannels,
);
